import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { FrameComponent } from './frame.component';
import { Daterangepicker } from 'ng2-daterangepicker';
import { NgxSpinnerModule } from 'ngx-spinner';
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    FormsModule,
    Daterangepicker
  ],
  declarations: [FrameComponent],
  exports: [
    FrameComponent
  ],
  providers: [
    
  ]
})
export class FrameModule { }
